/**
 * Created by jonas on 2022-06-15.
 */
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../../../TheCage";
import {TheCageStatics} from "../../../config/TheCageStatics";
import {TheCageSymbol, TheCageSymbolStates} from "../../../reels/TheCageSymbol";
import {GSAPUtils} from "../../../utils/GSAPUtils";
import {SimpleReelModelSymbolData} from "../../../../core/reel/simplereel/SimpleReelModel";


export class XBombPresentation implements SimplePresentation {
    name:string = "XBombPresentation";

    constructor() {
    }

    shouldRun():boolean {
        return TheCage.model.gameData.allWildMiningPositions.length <= 0;
    }

    start(controller:SimplePresentationRunnerController):void {

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});

/*
        tl.add(() => {
            controller.setSkipCallback(() => {
                tl.seek("ending", false);
            });
        });

*/

        const xBombSymbols = TheCage.reelView.avalancheMatrixModel.getAllSymbolsWithNamesFlippedRight(["WB"]);

        tl.add(this.getXBombAnimation(xBombSymbols));


/*        tl.addLabel("ending");
        tl.add(() => {controller.setSkipCallback()});*/
        tl.to(this, {duration:0.01});

    }

    private getXBombAnimation(xBombSymbols:SimpleReelModelSymbolData[]) {
        const tl = gsap.timeline();
        const originalLength = xBombSymbols.length;
        if (xBombSymbols.length <= 0){
            return tl;
        }

        const unExplodedBombs:SimpleReelModelSymbolData[] = [];
        const bombsToExplode:SimpleReelModelSymbolData[] = [];


        while (xBombSymbols.length > 0){
            const xBomb = xBombSymbols.pop()!;
            bombsToExplode.unshift(xBomb);
        }


        let bombCount = 0;
        for (let xBomb of bombsToExplode){
            const bombTl = gsap.timeline();
            const symbolsToRemove = [];

            const explodeTime = 0.56;

            let explodePositions = TheCageStatics.X_BOMB_CROSS_MAP[xBomb.reelId][xBomb.reelPosition];
            //explodePositions = explodePositions.concat(OctagonStatics.X_BOMB_SQUARE_MAP[xBomb.reelId][xBomb.reelPosition]);

            symbolsToRemove.push( ...TheCage.reelView.avalancheMatrixModel.getSymbolsAt(explodePositions));

            bombTl.add(TheCage.soundPlayer.playXBombExplode(bombCount));
            bombCount++;
            bombTl.add((<TheCageSymbol>xBomb.positionable).getStateAnimation(TheCageSymbolStates.EXPLODE));
            bombTl.add([
                () => {TheCage.reelView.multiplierDisplay.addMultiplier(1)},
                ()=>{TheCage.reelView.getExplodeShake()}
            ],explodeTime);
            xBomb.removed = true;

            const anims = [];
            for (let symbol of symbolsToRemove){
                if (TheCageStatics.isExplodableSymbol(symbol.name) && !symbol.removed){
                    symbol.removed = true;
                    anims.push((<TheCageSymbol>symbol.positionable).getStateAnimation(TheCageSymbolStates.REMOVE));
                }
            }
            bombTl.add(GSAPUtils.createTimelineFromArray(anims, "<"), explodeTime);


            explodePositions.push({x:xBomb.reelId, y: xBomb.reelPosition});

            tl.add(bombTl, "<0.1");

        }

        if (originalLength == unExplodedBombs.length){
            return tl;
        } else {
            tl.add(this.getXBombAnimation(unExplodedBombs))
        }


        return tl;
    }

}